var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertaInformacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 16,
    height: 16,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.6,
    height: 1.6,
    x: 7.2,
    y: 4,
    fill: "rgb(0,255,255)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.6,
    height: 4.8,
    x: 7.2,
    y: 7.2,
    fill: "rgb(0,255,255)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,255,255)",
    fillRule: "evenodd",
    d: "M0 8c0-4.41827393 3.58172607-8 8-8s8 3.58172607 8 8-3.58172607 8-8 8-8-3.58172607-8-8zm1.59997559 0c0 3.53460693 2.86535644 6.40002441 6.40002441 6.40002441C11.53259277 14.39514161 14.3951416 11.53259277 14.39996338 8c0-3.53460693-2.86535645-6.3999939-6.39996338-6.3999939-3.53466797 0-6.40002441 2.86538697-6.40002441 6.3999939z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaInformacao);
export default __webpack_public_path__ + "static/media/alerta_informacao.94ac7bfe39873c338eb41c9fbf949897.svg";
export { ForwardRef as ReactComponent };